// import React from 'react';
// export const ContextApp = React.createContext();
// export const ContextLastMessage = React.createContext();

export const initialState = [];
export const initialUsersInGroupChatData: any = [];

//Reducer + Context
//для манипуляций с сообщениями всех чатов
//для сохранения состояния строки отправки сообщения

export const MessagesAllChatReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'setAllChat':
      return [...state, action.res];
    case 'setNewMessage':
      const findElementInArrayState = state.find(
        (i: any) => action.data.message.receiver_id === i.session_id
      );
      findElementInArrayState.data = [...findElementInArrayState.data, action.data.message];
      return state;
    case 'setMyMessage':
      const findElementInArrayState2 = state.find(
        (i: any) => action.data.receiver_id === i.session_id
      );
      findElementInArrayState2.data = [...findElementInArrayState2.data, action.data];
      return state;
    default:
      return state;
  }
};
export const lastMessageReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'lastMessage':
      return [...state, ...action.lastMessageObj];
    case 'setFromChatMessage':
      // console.log('setFromChatMessage', state, action);
      action.data = state;
      return state;
    default:
      return state;
  }
};
//Для манипуляций со state'ом группового чата
export const groupChatReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'setUsersInGroup':
      action.data.map((i: any) => {
        state.user_id.push(i.user_id);
      });
      return state;
    case 'deleteUsersInGroup':
      state.user_id = action.arrayOfUsersWithOutOne;
      return state;

    case 'setUserFromGroup':
      // console.log('setUserFromGroup1', action, state);
      // state.user_id.push(action.user);
      state.user_id = [...state.user_id, action.user];
      return state;
    case 'deleteUserFromGroup':
      const myIndex = state.user_id.indexOf(action.user);
      if (myIndex !== -1) {
        state.user_id.splice(myIndex, 1);
      }
      return state;
    case 'addGroupName': //Добавляет название группы
      state.group_name = action.groupName;
      return state;
    case 'resetGroupChatState':
      state = {
        group_name: null,
        user_id: [],
      };
      return state;

    default:
      return state;
  }
};

export const usersInGroupChatReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'setUsersInGroup':
      return [...state, action.res];
    default:
      break;
  }
};
